export default function VideoSkeleton() {
  return (
    <div className="overflow-hidden px-5 my-2.5 rounded-300">
      <div className="w-full bg-surface-200-bg skeleton min-h-[200px]" />
    </div>
  );
}
